import { render, staticRenderFns } from "./roomRenovationManageList.vue?vue&type=template&id=4280f880&scoped=true"
import script from "./roomRenovationManageList.vue?vue&type=script&lang=js"
export * from "./roomRenovationManageList.vue?vue&type=script&lang=js"
import style0 from "./roomRenovationManageList.vue?vue&type=style&index=0&id=4280f880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280f880",
  null
  
)

export default component.exports